// Mirrors Swarm's EmailAddress::REGEX (app/models/email_address.rb): RFC 5321
// dot-atom local part — no leading, trailing, or consecutive dots (BEE-22114) —
// and a dotted host.
export const EMAIL_REGEX =
  /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
